export interface IExpertSystemRecipient {
    recipientId: number;
    centerId: number;
    alias: string;
    firstName: string;
    lastName: string;
    email: string;
    address1: string;
    address2: string;
    city: string;
    state: string;
    postalCode: string;
    birthDate: string;
    gender: string;
    phone: string;
    hasTyping: boolean;
}
